"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Ticket = function Ticket(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon icon-no-fill ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 20.25,12.263c0-1.657,1.343-3,3-3v-3.75c0-0.828-0.672-1.5-1.5-1.5H2.25c-0.828,0-1.5,0.672-1.5,1.5v3.75 c1.657,0,3,1.343,3,3s-1.343,3-3,3v3.75c0,0.828,0.672,1.5,1.5,1.5h19.5c0.828,0,1.5-0.672,1.5-1.5v-3.75 C21.593,15.263,20.25,13.92,20.25,12.263L20.25,12.263z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6.169,16.763c0.725,0.49,1.581,0.751,2.456,0.75 c1.284-0.011,2.506-0.554,3.375-1.5c0.869,0.946,2.091,1.489,3.375,1.5c0.875,0.001,1.731-0.26,2.456-0.75"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 8.25,15.263l-1.5-2.25 h10.5l-1.5,2.25"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 11.25,13.013v-6l4.5,3l-3.75,3"
  })));
};
Ticket.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Ticket.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Ticket;